'use strict';

import {convertDataVToVue} from '../apply_vue_data_directives.js';

export class Vipprofileguidewhycontent {
	constructor(component_id) {
		this.id = component_id;
		this.vars = yalwa.v.components[this.id];
		this.$root = jQuery(`.js-${this.id}`);
	}

	init() {
		const hide_for_edit = (bit) => {
			this.reshow_guide_after_edit = true;
			this.reshow_guide_bit = bit;
			const guide = yalwa.v.component_instances?.['dialog_vipguidewhy'];
			guide?.hide();
		};

		jQuery(document).off('click.vip_guide_avatar').on('click.vip_guide_avatar', '.js-vip_guide_gallery_upload_photo_trigger', () => {
			hide_for_edit(2);
			jQuery('.js-userprofile__edit_icon').trigger('click');
		});

		const section_edits = {
			'js-vip_guide_gallery_trigger': 'js-infoblock_gallery_edit',
			'js-vip_guide_contact_trigger': 'js-infoblock_contact_edit',
			'js-vip_guide_about_trigger': 'js-infoblock_aboutme_edit',
			'js-vip_guide_highlights_trigger': 'js-infoblock_highlight_edit',
			'js-vip_guide_services_trigger': 'js-infoblock_services_edit',
			'js-vip_guide_hours_trigger': 'js-infoblock_businesshours_edit',
			'js-vip_guide_location_trigger': 'js-infoblock_location_edit',
		};
		const section_edit_bits = {
			'js-vip_guide_gallery_trigger': 1,
			'js-vip_guide_contact_trigger': 4,
			'js-vip_guide_about_trigger': 16,
			'js-vip_guide_highlights_trigger': 32,
			'js-vip_guide_services_trigger': 64,
			'js-vip_guide_hours_trigger': 128,
			'js-vip_guide_location_trigger': 8,
		};
		const selectors = Object.keys(section_edits).map((cls) => '.' + cls).join(',');

		jQuery(document).off('click.vip_guide_edit').on('click.vip_guide_edit', selectors, (event) => {
			const button = event.target.closest('[class*="js-vip_guide_"]');
			const trigger_class = Object.keys(section_edits).find((cls) => button?.classList.contains(cls));

			if (!trigger_class) {
				return;
			}
			hide_for_edit(section_edit_bits[trigger_class]);
			jQuery('.' + section_edits[trigger_class]).trigger('click');
		});

		// When an edit dialog opened from the guide is closed or cancelled
		// (via close icon, Cancel button, or backdrop overlay), re-show the
		// profile completion guide dialog. (On Save, on_state handles re-showing
		// and clears reshow_guide_after_edit before the dialog closes).
		const section_dialogs = [
			'js-dialog_gallery',
			'js-dialog_website',
			'js-dialog_phone',
			'js-dialog_aboutme',
			'js-dialog_highlights',
			'js-dialog_services',
			'js-dialog_businesshours',
			'js-dialog_location'
		];
		const edit_dialog_selector = section_dialogs.map((cls) => '.' + cls).join(',');

		jQuery(document).off('click.vip_guide_edit_close').on('click.vip_guide_edit_close', (event) => {
			if (!this.reshow_guide_after_edit) {
				return;
			}
			const target = event.target;
			const dialog_el = target.closest?.(edit_dialog_selector);
			if (!dialog_el) {
				return;
			}
			const is_close_trigger = target.closest?.('.js-dialog_close, .dialog__close_icon, yalwa-button[intent="secondary"], [data-v-click*="close"]');
			const is_backdrop = target === dialog_el || jQuery(target).hasClass('dialog__position');

			if (!is_close_trigger && !is_backdrop) {
				return;
			}

			this.reshow_guide_after_edit = false;
			this.reshow_guide_bit = null;

			setTimeout(() => {
				jQuery('.js-dialog_vipguidewhy').appendTo('body');
				const dialog = yalwa.v.component_instances?.['dialog_vipguidewhy'];
				dialog?.show();
			}, 50);
		});
	}

	vue_setup(Vue) {
		const ythis = this;

		if (!this.$root) {
			console.error(`Vue JS container not found for ID: ${this.id}`);
			return {};
		}

		const rootx = document.querySelector(`.js-${this.id}`);
		const template = `${convertDataVToVue(rootx)}`;

		return Vue.defineComponent({
			delimiters: ['[[', ']]'],
			name: this.id,
			template,
			setup() {
				const completion_pct = Vue.ref(ythis.vars?.data?.pct ?? 0);
				const sections = Vue.ref(ythis.vars?.data?.sections ?? 0);
				const rows = ythis.vars?.data?.rows ?? [];
				const why_benefits = ythis.vars?.data?.why_benefits ?? [];
				const required_icon = ythis.vars?.data?.required_icon ?? '';
				const filled_icon = ythis.vars?.data?.filled_icon ?? '';
				const edit_icon = ythis.vars?.data?.edit_icon ?? '';
				const collapse_icon = ythis.vars?.data?.collapse_icon ?? '';
				const sparkle_icon = ythis.vars?.data?.sparkle_icon ?? '';
				const info_icon = ythis.vars?.data?.info_icon ?? '';
				const value = ythis.vars?.data?.contact_value ?? null;
				const revealedNumber = Vue.ref(null);
				const aboutme_text = ythis.vars?.data?.aboutme_value ?? '';
				const value_display = aboutme_text.replace(/\n/g, '<br>');
				const valueBE = aboutme_text;
				const expanded = Vue.ref(false);
				const isOverflowing = false;
				const highlightsFromBE = ythis.vars?.data?.highlights_value ?? [];
				const servicesFromBE = ythis.vars?.data?.services_value ?? [];
				const businessHoursDB = ythis.vars?.data?.businesshours_value ?? [];
				const hasData = businessHoursDB.length > 0;
				const locationsFromBE = ythis.vars?.data?.location_value ?? [];
				const current_view = Vue.ref('why');
				const expanded_row_id = Vue.ref(null);

				// profile section saves deliver fresh completion state; rows
				// flip to done and the % updates without a reload
				const on_state = (event) => {
					const state = event.detail;

					if (!state) {
						return;
					}
					completion_pct.value = state.pct;
					sections.value = state.sections;

					if (ythis.reshow_guide_after_edit) {
						const edited_bit = ythis.reshow_guide_bit;

						// The edited section is now done (its bit is set): collapse its row
						if (edited_bit && (state.sections & edited_bit) > 0 && expanded_row_id.value !== null) {
							expanded_row_id.value = null;
						}

						// The gallery dialog stays open after an image upload so the user
						// can add several images; the guide is re-shown only once the user
						// closes the gallery dialog themselves (see click.vip_guide_gallery_close).
						if (edited_bit === 1) {
							return;
						}

						ythis.reshow_guide_after_edit = false;
						ythis.reshow_guide_bit = null;

						jQuery('.js-dialog_vipguidewhy').appendTo('body');
						const dialog = yalwa.v.component_instances?.['dialog_vipguidewhy'];
						dialog?.show();
					}
				};
				document.addEventListener('vip_guide_state', on_state);

				const scroll_row_into_view = (row_id) => {
					Vue.nextTick(() => {
						setTimeout(() => {
							const container = document.querySelector('.vipprofileguidewhycontent__rows');
							const row_el = document.querySelector('.vipprofileguidewhycontent__row--expanded')
								|| container?.children[row_id];
							if (!container || !row_el) {
								return;
							}
							const container_rect = container.getBoundingClientRect();
							const row_rect = row_el.getBoundingClientRect();
							const row_top_relative = row_rect.top - container_rect.top + container.scrollTop;
							const target_scroll_top = row_top_relative - (container.clientHeight / 2) + (row_el.clientHeight / 2);

							container.scrollTo({
								top: Math.max(0, target_scroll_top),
								behavior: 'smooth',
							});
						}, 150);
					});
				};

				const on_view_change = (event) => {
					if (event.detail?.view) {
						current_view.value = event.detail.view;
					}
					if (typeof event.detail?.row_id !== 'undefined') {
						expanded_row_id.value = event.detail.row_id;
						scroll_row_into_view(expanded_row_id.value);
					} else if (event.detail?.bit) {
						const bit = Number(event.detail.bit);
						const target_row = rows.find((r) => Number(r.bit) === bit);
						if (target_row) {
							expanded_row_id.value = target_row.id;
							scroll_row_into_view(target_row.id);
						}
					}
				};
				document.addEventListener('vip_guide_dialog_view', on_view_change);

				const rows_done = Vue.computed(() => rows.map(row => ({
					...row,
					done: (sections.value & row.bit) > 0,
					expanded: expanded_row_id.value === row.id,
				})));

				const bar_color = Vue.computed(() => {
					if (completion_pct.value <= 40) {
						return 'red';
					}
					if (completion_pct.value <= 70) {
						return 'orange';
					}
					return 'green';
				});

				const bar_style = Vue.computed(() => ({
					width: completion_pct.value + '%',
				}));

				const fill_class = Vue.computed(() => ({
					'vipprofileguidewhycontent__fill--red': bar_color.value === 'red',
					'vipprofileguidewhycontent__fill--orange': bar_color.value === 'orange',
					'vipprofileguidewhycontent__fill--green': bar_color.value === 'green',
				}));

				const row_class = (row) => ({
					'vipprofileguidewhycontent__row--done': row.done,
					'vipprofileguidewhycontent__row--expanded': row.expanded,
				});

				const section_edit_triggers = {
					2: 'js-userprofile__edit_icon',
					1: 'js-infoblock_gallery_edit',
					4: 'js-infoblock_contact_edit',
					16: 'js-infoblock_aboutme_edit',
					32: 'js-infoblock_highlight_edit',
					64: 'js-infoblock_services_edit',
					128: 'js-infoblock_businesshours_edit',
					8: 'js-infoblock_location_edit',
				};

				const toggle_row = (rowID) => {
					expanded_row_id.value = expanded_row_id.value === rowID ? null : rowID;
					if (expanded_row_id.value === rowID) {
						scroll_row_into_view(rowID);
					}
				};

				const open_section_edit = (row) => {
					const post_url = ythis.vars?.data?.post_url ?? null;

					if (row.bit === 256) {
						if (post_url) {
							window.location.href = post_url;
						}
						return;
					}
					const edit_trigger = section_edit_triggers[row.bit];

					if (edit_trigger) {
						ythis.reshow_guide_after_edit = true;
						ythis.reshow_guide_bit = row.bit;
						const guide = yalwa.v.component_instances?.['dialog_vipguidewhy'];
						guide?.hide();
						jQuery('.' + edit_trigger).trigger('click');
					}
				};

				const row_marker_click = (rowID) => {
					const row = rows.find((r) => r.id === rowID);

					if (!row) {
						return;
					}
					if ((sections.value & row.bit) > 0) {
						open_section_edit(row);
						return;
					}
					toggle_row(rowID);
				};

				// The embedded example infoblock ships its own Vue directives
				// (data-v-click on prefix/suffix icons); its Vue never mounts inside
				// this dialog, so expose no-ops to keep clicks from throwing.
				const prefixIconClick = () => {};
				const suffixIconClick = () => {};
				const openDialog = () => {};

				// Contact example block: its view template binds against `value`,
				// `revealedNumber`, `revealNumber` and `callNumber` — provide them
				// from the server-provided example data.
				const revealNumber = () => {
					revealedNumber.value = value?.phone?.phone_display ?? null;
				};
				const callNumber = () => {};

				const switch_view = (viewName) => {
					current_view.value = viewName;
				};

				let info_slider = null;

				const open_info_icon = () => {
					jQuery('html').addClass('js-no_scroll');
					jQuery('.js-dialog_infoicon').appendTo('body');
					yalwa.v.component_instances['dialog_infoicon']?.show();

					info_slider = new yalwa.basics.simple_auto_slide({
						css_prefix: 'infocard__',
						timeout: 7000,
						container_class: 'js-simple_auto_slide_vipinfo',
						bullets: { container_class: 'js-slider_vipinfo_pagination_container' },
						clickable: false,
					});
					info_slider.start();

					if (window.innerWidth <= 765) {
						jQuery('.js-slider_vipinfo_pagination_container').appendTo('.js-pagination_header');
					}
				};

				return {
					completion_pct,
					sections,
					rows_done,
					why_benefits,
					value,
					revealedNumber,
					revealNumber,
					callNumber,
					value_display,
					valueBE,
					expanded,
					isOverflowing,
					highlightsFromBE,
					servicesFromBE,
					businessHoursDB,
					hasData,
					locationsFromBE,
					required_icon,
					filled_icon,
					edit_icon,
					collapse_icon,
					sparkle_icon,
					info_icon,
					current_view,
					toggle_row,
					row_marker_click,
					open_info_icon,
					prefixIconClick,
					suffixIconClick,
					openDialog,
					switch_view,
					bar_style,
					fill_class,
					row_class,
				};
			},
		});
	}
}
